import React, {Component} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Paper from 'material-ui/Paper';
import {
  Route,
} from 'react-router-dom'
import BottomNavigation from 'material-ui/BottomNavigation';
import {BottomNavigationItem} from "material-ui/BottomNavigation/index";
import FontIcon from 'material-ui/FontIcon';

import AnmeldungSchritteComponent from './components/anmeldung-schritte/AnmeldungSchritteComponent'
import ParentComponent from './components/parent/ParentComponent'
import ChildComponent from './components/child/ChildComponent'
import WelcomeComponent from './components/welcome/WelcomeComponent'
import KeineAnmeldungMoeglichForm from './components/keine-anmeldung-moeglich/KeineAnmeldungMoeglichForm'
import AnmeldungAbgeschlossenComponent from './components/anmeldung-abgeschlossen/AnmeldungAbgeschlossenComponent'
import Zusammenfassung from './components/zusammenfassung/ZusammenfassungComponent'
import SettingsComponent from './components/settings/SettingsComponent'
import AnmeldungBestaetigenComponent from './components/anmeldung-bestaetigen/AnmeldungBestaetigenComponent'

import './App.css';

const impressumIcon = <FontIcon className="material-icons">Impressum</FontIcon>
const datenschutzIcon = <FontIcon className="material-icons">Datenschutzerklärung</FontIcon>

const style = {
  margin: 20,
  padding: 20,
  textAlign: 'center',
  display: 'inline-block',
  minWidth: '150px',
  width: '95%'
};

const ReactiveStepper = (step, component) => {
  return <AnmeldungSchritteComponent activeStep={step}>
    {component}
  </AnmeldungSchritteComponent>
};

const ErsteSeite = () => {
  return ReactiveStepper(-1, <WelcomeComponent nextRoute='/start'/>);
};

const ElternDaten = () => {
  return ReactiveStepper(0, <ParentComponent nextRoute='/kind/1'/>);
};

const Kind = ({match}) => {
  let kindNr = parseInt(match.params.kindNr, 10);
  return ReactiveStepper(1,
    <ChildComponent
      key={`childComponent-${kindNr}`}
      kindNr={kindNr}
      previousRoute={ (kindNr <= 1) ? '/start' : `/kind/${kindNr - 1}` }
      nextRoute={`/kind/${kindNr + 1}`}
      summaryRoute='/summary'
    />
  );
};

const ZusammenfassungAnzeigen = (props) => {
  return ReactiveStepper(2,
    <Zusammenfassung previousRoute="/start"/>, props);
};

const Abgeschlossen = (props) => {
  return ReactiveStepper(3, <AnmeldungAbgeschlossenComponent nextRoute="/start"/>, props);
};

const Settings = () => {
  return <SettingsComponent nextRoute="/start"/>
};

const AnmeldungBestaetigen = ({match}) => {
  return <AnmeldungBestaetigenComponent uuid={match.params.uuid}/>
};

export default class App extends Component {
  render() {
    return (
      <MuiThemeProvider>
        <div className="App">
          <Paper style={style}
                 zDepth={3}> { /* TODO: Größe ermitteln und SchritteHorizontal > 1020px oder SchritteVertical verwenden.*/ }
            <Route exact path="/" component={KeineAnmeldungMoeglichForm}/>
            {/*<Route path="/start" component={ElternDaten}/>
            <Route path="/kind/:kindNr" component={Kind}/>
            <Route path="/summary" component={ZusammenfassungAnzeigen}/>
            <Route path="/fast-fertig" component={Abgeschlossen}/>
            <Route path="/settings" component={Settings}/>*/}
            <Route path="/anmeldung-bestaetigen/:uuid" component={AnmeldungBestaetigen}/>
            <br/><br/>
            <BottomNavigation>
              <a href="http://www.ratzgiwatz.de/impressum/">
                <BottomNavigationItem
                  icon={impressumIcon}
                />
              </a>
              <a href="http://www.ratzgiwatz.de/datenschutzerklaerung/">
                <BottomNavigationItem
                  icon={datenschutzIcon}
                />
              </a>
            </BottomNavigation>
          </Paper>
        </div>
      </MuiThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js